import { createSelector } from 'reselect';

//
import { getFormSubmitFailedSelector, getFormSyncErrorsSelector } from '@redux/reducers/form/formSelector';
import { getIsSignedInSelector } from '@redux/reducers/user/userSelector';
import { isEmptyObject } from '@utils/object';

const invalidAddressFormState = createSelector(
  [getFormSubmitFailedSelector, getFormSyncErrorsSelector, getIsSignedInSelector],
  (submitFailed, syncErrors, isSignedIn) => ({
    showInitialErrorMessage: !submitFailed && !isEmptyObject(syncErrors),
    isSignedIn,
  }),
);

export default invalidAddressFormState;
